import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    theme: 'light',
    locale: 'ar',
    direction: 'rtl',
    bridg: [],
    zoom: 100 // القيمة الافتراضية 100%
}

const AppSlice = createSlice({
    name: 'app',
    initialState,
    reducers: {
        changeApp: (state, action) => {
            state.theme = !!action?.payload?.theme ? action?.payload?.theme : state.theme;
            state.locale = !!action?.payload?.locale ? action?.payload?.locale : state.locale;
            state.direction = !!action?.payload?.direction ? action?.payload?.direction : state.direction;
            state.zoom = !!action?.payload?.zoom ? action?.payload?.zoom : state.zoom;
        },
        changeBridg: (state, action) => {
            state.bridg = !!action?.payload?.bridg ? action?.payload?.bridg : state.bridg;
        },
        reset: () => initialState
    },
});
export const {
    reset,
    changeApp,
    changeBridg
} = AppSlice.actions;

export default AppSlice.reducer;
